import PopularBadge from "@core-components/PopularBadge";
import GradientBorder from "@core-components/gradient-border/GradientBorder";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Badge, Button, Flex } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import type IBasketAccount from "@modules/order/stores/models/IBasketItem.models";
import useBuyModalStore from "@store/buyModal.store";
import AppBuyButton from "./AppBuyButton";

interface ISSBoughtFooterCardProps {
  account: IBasketAccount;
  isOutOfStock?: boolean;
  isPopular?: boolean;
}

const SSBoughtFooterCard: React.FC<ISSBoughtFooterCardProps> = ({
  account,
  isOutOfStock = false,
  isPopular = false,
}) => {
  const { open } = useBuyModalStore();
  const { t } = useAppTranslation("components.boughtFooterCard");

  return (
    <>
      <Button.Group className="relative">
        <Flex className="w-full">
          <GradientBorder
            className={`${isOutOfStock ? "light-gradient-purple-to-transparent rounded-r-[12px]" : "gradient-purple-to-transparent"} grow items-center justify-start rounded-l-[12px] pr-0`}
            childrenClassName="!bg-primary-default text-primary-white font-bold flex items-center p-3 gap-2"
          >
            <AppSkeleton>
              <span
                className={`${isOutOfStock ? "text-primary-dark-text" : ""} pt-[2px] leading-none`}
              >
                {account.price}€
              </span>
            </AppSkeleton>
            {isPopular && !isOutOfStock && <PopularBadge />}
          </GradientBorder>

          {!isOutOfStock && (
            <AppBuyButton
              label={isOutOfStock ? t("outOfStock") : t("buy")}
              onClick={() => open(account)}
            />
          )}
        </Flex>
        {isOutOfStock && (
          <Badge
            className="-translate-y-1/2 absolute top-1/2 right-2 "
            color="red"
            radius="sm"
            size="md"
            variant="light"
          >
            {t("outOfStockBadge")}
          </Badge>
        )}
      </Button.Group>
    </>
  );
};

export default SSBoughtFooterCard;
